import { Component, ElementRef, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { TipoCampo } from '../models/columna-orden';

@Component({
  selector: 'app-titulo-sort',
  templateUrl: './titulo-sort.component.html',
  styles: ['.titulo-sort-ordenable { cursor: pointer; }']
})
export class TituloSortComponent implements OnInit {

  @Input() campo: string;
  @Input() tipo: TipoCampo = 'texto';
  @Input() orderColumn: string;
  @Input() orderDirection: string;
  @Input() ordenable: boolean = true;

  @Output() sortData = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
  }

  get etiqueta(): string {
    const contenido = this.elementRef.nativeElement.textContent;

    return contenido ? contenido.trim() : '';
  }

  onClick(): void {
    if (!this.ordenable) {
      return;
    }

    this.sortData.emit(this.campo);
  }
}
